import { getPolygonHeadings } from 'common/components/segment/asceHelpers';
import { getDictionaryById } from 'common/components/segment/helpers';

import { INITIALIZE_VALUES } from '../actionTypes';
import { panelLayoutV2Actions } from '../reducer';
import * as selectors from '../selectors';

export default (segmentId, google) => (dispatch, getState) => {
    const state = getState();
    const segments = selectors.getSegmentsData(state);
    const segmentsDictionary = getDictionaryById(segments);
    if (!segmentsDictionary[segmentId]) return;

    const polygonHeadings = getPolygonHeadings({
        google,
        polygonCoords: segmentsDictionary[segmentId].polygon,
    });

    const azimuthSelectorValue = polygonHeadings.filter(
        ({ heading }) =>
            parseFloat(heading) ===
            parseFloat(segmentsDictionary[segmentId].azimuth),
    );
    let azimuth_selector = 'custom';

    if (azimuthSelectorValue.length > 0) {
        azimuth_selector = azimuthSelectorValue[0].heading;
    }

    dispatch(
        panelLayoutV2Actions[INITIALIZE_VALUES]({
            ...segmentsDictionary[segmentId],
            azimuth_selector,
        }),
    );
};
